import React from "react";
import { routes } from "../../helpers/constants";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const Page404 = () => {
  const navigate = useNavigate();
  const handleGoBackPage = () => {
    navigate(routes.homepage);
  };

  return (
    <div>
      <div style={{ color: "grey", textAlign: "center", marginTop: "4rem" }}>
        <h1>Page 404 not found</h1>
        <Button className="mt-3" onClick={() => handleGoBackPage()}>
          {`Go To Dashboard`}
        </Button>
      </div>
    </div>
  );
};

export default Page404;
